

export const WorkUploadChart = {
    tooltips: {
        callbacks: {
            label: function (tooltipItem, data) {
                const label = data.datasets[tooltipItem.datasetIndex].label || '';
                const value = tooltipItem.yLabel;
                return `${label}: ${value} Nos`;
            }
        }
    },

    layout: {
        padding: {
            top: 10,
            bottom: 10
        }
    },
    legend: {
        display: false
    },
    plugins: {
        labels: {
            render: 'value',
            fontColor: 'black',

        },
        outlabels: {
            color: "black",
            // text: "%l\n%v (%p)",
            stretch: 15,
            font: {
                resizable: true,
                minSize: 12,
                maxSize: 16
            }
        },
    },

    scales: {

        xAxes: [{
            stacked: false,
            gridLines: {
                drawOnChartArea: false
            },
            barThickness: 40,

            ticks: {
                autoSkip: false,

            }
        }],

        yAxes: [{
            stacked: false,
            gridLines: {
                drawOnChartArea: false
            },
            ticks: {
                beginAtZero: true
            }
        }]
    }
}



export const WorkAssign = {
    tooltips: {
        callbacks: {
            label: function (tooltipItem, data) {
                const label = data.datasets[tooltipItem.datasetIndex].label || '';
                const value = tooltipItem.yLabel;
                return `${label}: ${value} Nos`;
            }
        }
    },

    layout: {
        padding: {
            top: 10,
            bottom: 10,
        },
    },
    legend: {
        display: false
    },

    plugins: {
        labels: {
            render: 'value',
            fontColor: 'black',

        },
        legend: {
            display: false
        },
        outlabels: {
            color: "black",
            // text: "%l\n%v (%p)",
            stretch: 15,
            font: {
                resizable: true,
                minSize: 12,
                maxSize: 16
            }
        },
    },

    scales: {

        xAxes: [{
            stacked: false,
            gridLines: {
                drawOnChartArea: false
            },
            barThickness: 30,


            ticks: {
                autoSkip: false,

            }
        }],

        yAxes: [{
            stacked: false,
            gridLines: {
                drawOnChartArea: false
            },
            ticks: {
                beginAtZero: true
            }
        }]
    }
}




export const Dcoptions = {

    layout: {
        padding: {
            // top: 70,
            // bottom: 10
        }
    },
    legend: {
        // position: 'chartArea',
        // align: 'start',
        display: false
    },
    plugins: {
        labels: {
            render: 'value',
            fontColor: 'black'
        },
        outlabels: {
            color: "black",
            // text: "%l\n%v (%p)",
            stretch: 15,
            font: {
                resizable: true,
                minSize: 12,
                maxSize: 16
            }
        },
    },

    scales: {

        xAxes: [{
            stacked: false,
            gridLines: {
                drawOnChartArea: false
            },
            barThickness: 30,
            ticks: {
                autoSkip: false,

            }
        }],
        yAxes: [{
            stacked: false,
            gridLines: {
                drawOnChartArea: false
            },
            ticks: {
                beginAtZero: true
            }
        }]
    }
}



export const Pieoptions = {
    layout: {
        padding: {
            top: 10,
            bottom: 0
        }
    },
    legend: {
        display: false
    },
    plugins: {
        labels: {
            render: 'value',
            fontColor: 'black'
        },
        outlabels: {
            color: "black",
            // text: "%l\n%v (%p)",
            stretch: 12,
            font: {
                resizable: true,
                minSize: 12,
                maxSize: 16
            }
        },
    },
}

// scales: {
//     xAxes: [{
//         gridLines: {
//             drawOnChartArea: false
//         },
//         ticks: {
//             autoSkip: false,
//             maxRotation: 90,
//             minRotation: 90
//         }
//     }],
//     yAxes: [{
//         gridLines: {
//             drawOnChartArea: false
//         }
//     }]
// }


export const ServicePieoptions = {
    layout: {

    },
    legend: {
        display: false
    },
    plugins: {
        labels: {
            render: 'value',
            fontColor: 'black'
        },
        outlabels: {
            color: "black",
            // text: "%l\n%v (%p)",
            stretch: 0,
            font: {
                resizable: true,
                minSize: 12,
                maxSize: 16
            }
        },
    },
}



export const PillerCurrentRatingTableData = [
    {
        srNo: 1,
        sectorName: "Agroli Talav, Sec 14",
        areaName: "",
        miniPillarNo: "MP_S10_1",
        phases: [
            {
                phase: "R",
                records: [
                    {
                        time: "07.00",
                        days: {
                            "01": 7.32, "02": 7.32, "03": 7.32, "04": 7.32,
                            "05": 7.32, "06": 7.32, "07": 7.32, "08": 7.32,
                            "09": 7.32, "10": 7.32, "11": 7.32, "12": 7.32,
                            "13": 7.32, "14": 7.32, "15": 7.32, "16": 7.32,
                            "17": 7.32, "18": 7.32, "19": 7.32, "20": 7.32,
                            "21": 7.32, "22": 7.32, "23": 7.32, "24": 7.32,
                            "25": 7.32, "26": 7.32, "27": 7.32, "28": 7.32,
                            "29": 7.32, "30": 7.32, "31": 7.32
                        },

                    },
                    {
                        time: "08.00",
                        days: {
                            "01": 7.32, "02": 7.32, "03": 7.32, "04": 7.32,
                            "05": 7.32, "06": 7.32, "07": 7.32, "08": 7.32,
                            "09": 7.32, "10": 7.32, "11": 7.32, "12": 7.32,
                            "13": 7.32, "14": 7.32, "15": 7.32, "16": 7.32,
                            "17": 7.32, "18": 7.32, "19": 7.32, "20": 7.32,
                            "21": 7.32, "22": 7.32, "23": 7.32, "24": 7.32,
                            "25": 7.32, "26": 7.32, "27": 7.32, "28": 7.32,
                            "29": 7.32, "30": 7.32, "31": 7.32
                        }
                    },
                    {
                        time: "09.00",
                        days: {
                            "01": 7.32, "02": 7.32, "03": 7.32, "04": 7.32,
                            "05": 7.32, "06": 7.32, "07": 7.32, "08": 7.32,
                            "09": 7.32, "10": 7.32, "11": 7.32, "12": 7.32,
                            "13": 7.32, "14": 7.32, "15": 7.32, "16": 7.32,
                            "17": 7.32, "18": 7.32, "19": 7.32, "20": 7.32,
                            "21": 7.32, "22": 7.32, "23": 7.32, "24": 7.32,
                            "25": 7.32, "26": 7.32, "27": 7.32, "28": 7.32,
                            "29": 7.32, "30": 7.32, "31": 7.32
                        }
                    },
                    {
                        time: "10.00",
                        days: {
                            "01": 7.32, "02": 7.32, "03": 7.32, "04": 7.32,
                            "05": 7.32, "06": 7.32, "07": 7.32, "08": 7.32,
                            "09": 7.32, "10": 7.32, "11": 7.32, "12": 7.32,
                            "13": 7.32, "14": 7.32, "15": 7.32, "16": 7.32,
                            "17": 7.32, "18": 7.32, "19": 7.32, "20": 7.32,
                            "21": 7.32, "22": 7.32, "23": 7.32, "24": 7.32,
                            "25": 7.32, "26": 7.32, "27": 7.32, "28": 7.32,
                            "29": 7.32, "30": 7.32, "31": 7.32
                        }
                    }
                ]
            },
            {
                phase: "Y",
                records: [
                    {
                        time: "07.00",
                        days: {
                            "01": 7.32, "02": 7.32, "03": 7.32, "04": 7.32,
                            "05": 7.32, "06": 7.32, "07": 7.32, "08": 7.32,
                            "09": 7.32, "10": 7.32, "11": 7.32, "12": 7.32,
                            "13": 7.32, "14": 7.32, "15": 7.32, "16": 7.32,
                            "17": 7.32, "18": 7.32, "19": 7.32, "20": 7.32,
                            "21": 7.32, "22": 7.32, "23": 7.32, "24": 7.32,
                            "25": 7.32, "26": 7.32, "27": 7.32, "28": 7.32,
                            "29": 7.32, "30": 7.32, "31": 7.32
                        }
                    },
                    {
                        time: "08.00",
                        days: {
                            "01": 7.32, "02": 7.32, "03": 7.32, "04": 7.32,
                            "05": 7.32, "06": 7.32, "07": 7.32, "08": 7.32,
                            "09": 7.32, "10": 7.32, "11": 7.32, "12": 7.32,
                            "13": 7.32, "14": 7.32, "15": 7.32, "16": 7.32,
                            "17": 7.32, "18": 7.32, "19": 7.32, "20": 7.32,
                            "21": 7.32, "22": 7.32, "23": 7.32, "24": 7.32,
                            "25": 7.32, "26": 7.32, "27": 7.32, "28": 7.32,
                            "29": 7.32, "30": 7.32, "31": 7.32
                        }
                    },
                    {
                        time: "09.00",
                        days: {
                            "01": 7.32, "02": 7.32, "03": 7.32, "04": 7.32,
                            "05": 7.32, "06": 7.32, "07": 7.32, "08": 7.32,
                            "09": 7.32, "10": 7.32, "11": 7.32, "12": 7.32,
                            "13": 7.32, "14": 7.32, "15": 7.32, "16": 7.32,
                            "17": 7.32, "18": 7.32, "19": 7.32, "20": 7.32,
                            "21": 7.32, "22": 7.32, "23": 7.32, "24": 7.32,
                            "25": 7.32, "26": 7.32, "27": 7.32, "28": 7.32,
                            "29": 7.32, "30": 7.32, "31": 7.32
                        }
                    },
                    {
                        time: "10.00",
                        days: {
                            "01": 7.32, "02": 7.32, "03": 7.32, "04": 7.32,
                            "05": 7.32, "06": 7.32, "07": 7.32, "08": 7.32,
                            "09": 7.32, "10": 7.32, "11": 7.32, "12": 7.32,
                            "13": 7.32, "14": 7.32, "15": 7.32, "16": 7.32,
                            "17": 7.32, "18": 7.32, "19": 7.32, "20": 7.32,
                            "21": 7.32, "22": 7.32, "23": 7.32, "24": 7.32,
                            "25": 7.32, "26": 7.32, "27": 7.32, "28": 7.32,
                            "29": 7.32, "30": 7.32, "31": 7.32
                        }
                    }
                ]
            },
            {
                phase: "B",
                records: [
                    {
                        time: "07.00",
                        days: {
                            "01": 7.32, "02": 7.32, "03": 7.32, "04": 7.32,
                            "05": 7.32, "06": 7.32, "07": 7.32, "08": 7.32,
                            "09": 7.32, "10": 7.32, "11": 7.32, "12": 7.32,
                            "13": 7.32, "14": 7.32, "15": 7.32, "16": 7.32,
                            "17": 7.32, "18": 7.32, "19": 7.32, "20": 7.32,
                            "21": 7.32, "22": 7.32, "23": 7.32, "24": 7.32,
                            "25": 7.32, "26": 7.32, "27": 7.32, "28": 7.32,
                            "29": 7.32, "30": 7.32, "31": 7.32
                        }
                    },
                    {
                        time: "08.00",
                        days: {
                            "01": 7.32, "02": 7.32, "03": 7.32, "04": 7.32,
                            "05": 7.32, "06": 7.32, "07": 7.32, "08": 7.32,
                            "09": 7.32, "10": 7.32, "11": 7.32, "12": 7.32,
                            "13": 7.32, "14": 7.32, "15": 7.32, "16": 7.32,
                            "17": 7.32, "18": 7.32, "19": 7.32, "20": 7.32,
                            "21": 7.32, "22": 7.32, "23": 7.32, "24": 7.32,
                            "25": 7.32, "26": 7.32, "27": 7.32, "28": 7.32,
                            "29": 7.32, "30": 7.32, "31": 7.32
                        }
                    },
                    {
                        time: "09.00",
                        days: {
                            "01": 7.32, "02": 7.32, "03": 7.32, "04": 7.32,
                            "05": 7.32, "06": 7.32, "07": 7.32, "08": 7.32,
                            "09": 7.32, "10": 7.32, "11": 7.32, "12": 7.32,
                            "13": 7.32, "14": 7.32, "15": 7.32, "16": 7.32,
                            "17": 7.32, "18": 7.32, "19": 7.32, "20": 7.32,
                            "21": 7.32, "22": 7.32, "23": 7.32, "24": 7.32,
                            "25": 7.32, "26": 7.32, "27": 7.32, "28": 7.32,
                            "29": 7.32, "30": 7.32, "31": 7.32
                        }
                    },
                    {
                        time: "10.00",
                        days: {
                            "01": 7.32, "02": 7.32, "03": 7.32, "04": 7.32,
                            "05": 7.32, "06": 7.32, "07": 7.32, "08": 7.32,
                            "09": 7.32, "10": 7.32, "11": 7.32, "12": 7.32,
                            "13": 7.32, "14": 7.32, "15": 7.32, "16": 7.32,
                            "17": 7.32, "18": 7.32, "19": 7.32, "20": 7.32,
                            "21": 7.32, "22": 7.32, "23": 7.32, "24": 7.32,
                            "25": 7.32, "26": 7.32, "27": 7.32, "28": 7.32,
                            "29": 7.32, "30": 7.32, "31": 7.32
                        }
                    }
                ]
            }
        ],
        summary: {
            benchmarkMax: 19.36,
            min: 21.29,
            max: 21.29,
            defaulterAmp: 90,
            unitPenalty: 50.0,
            totalPenalty: 4500.0,
        },

        avgSum: {
            "01": 7.32, "02": 7.32, "03": 7.32, "04": 7.32,
            "05": 7.32, "06": 7.32, "07": 7.32, "08": 7.32,
            "09": 7.32, "10": 7.32, "11": 7.32, "12": 7.32,
            "13": 7.32, "14": 7.32, "15": 7.32, "16": 7.32,
            "17": 7.32, "18": 7.32, "19": 7.32, "20": 7.32,
            "21": 7.32, "22": 7.32, "23": 7.32, "24": 7.32,
            "25": 7.32, "26": 7.32, "27": 7.32, "28": 7.32,
            "29": 7.32, "30": 7.32, "31": 7.32
        },


        defaulterDays: {
            "01": 7.32, "02": 7.32, "03": 7.32, "04": 7.32,
            "05": 7.32, "06": 7.32, "07": 7.32, "08": 7.32,
            "09": 7.32, "10": 7.32, "11": 7.32, "12": 7.32,
            "13": 7.32, "14": 7.32, "15": 7.32, "16": 7.32,
            "17": 7.32, "18": 7.32, "19": 7.32, "20": 7.32,
            "21": 7.32, "22": 7.32, "23": 7.32, "24": 7.32,
            "25": 7.32, "26": 7.32, "27": 7.32, "28": 7.32,
            "29": 7.32, "30": 7.32, "31": 7.32
        },
        defaultersummary: [
            {
            benchmarkMax: '',
            minmax: '',
            defaulterAmp: 90,
            unitPenalty: 50,
            totalPenalty: 4500,
        }
    ],
    }
];
